import { useBusinessInfo } from '~/lib/Queries';

const PackageRedemptionClientText = ({ client, className }) => {
    const { data } = useBusinessInfo();

    const distinctByName = data?.clientDistinct === 'name';

    return (
        <div className={className}>
            {distinctByName && (
                <>
                    This will be automatically redeemed when this client books
                    as {client?.name}{' '}
                    {!!client?.email ? ` (${client?.email})` : ''}.
                </>
            )}
            {!distinctByName && (
                <>
                    This will be automatically redeemed when this client books
                    with their email address
                    {!!client?.email ? ` (${client?.email})` : ''}.
                </>
            )}
        </div>
    );
};

export default PackageRedemptionClientText;
